import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface ProjectUserMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allProjectUserMaster: [] | null | any;
}
const initialState: ProjectUserMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allProjectUserMaster: null
};
export const projectUserMasterSlice = createSlice({
  name: 'projectUserMaster',
  initialState,
  reducers: {
    setAllProjectUserMaster: (state, action) => {
      state.allProjectUserMaster = action.payload.data;
    },
    setProjectUserMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllProjectUserMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllProjectUserMaster, setProjectUserMaster, setAllProjectUserMasterBySearch,reset } = projectUserMasterSlice.actions;
export const allProjectUserMasterDetails = (state: RootState) => state.projectUserMaster.allProjectUserMaster;
export const getAllProjectUserMasterDetails = (state: RootState) => state.projectUserMaster.data;
export const getProjectUserMasterTotalRecords=(state:RootState)=>state.projectUserMaster.totalRecords;
export const getAllProjectUserMasterBySearch = (state: RootState) => state.projectUserMaster.data;
export default projectUserMasterSlice.reducer;